import React from "react";
import "./Welcome.css";
import logo from "../assets/logo.jpg"; // Tło logo

const Welcome = () => {
  return (
    <div className="main-section">
      <div className="logo-section">
        <img src={logo} alt="Logo" className="logo-image" />
        <span className="logo-text">EKSELOWE.PL</span>
      </div>
      <div className="main-heading">
        <h1 className="heading-line">Optymalizacja</h1>
        <h1 className="heading-line">Biznesu</h1>
      </div>
      <p className="subheading">EXCEL | Budowa narzędzi | Wdrożenie | Wsparcie | Szkolenia | Aplikacje</p>
    </div>

  );
};

export default Welcome;
